const RANKING_ITEMS = [
  { rank: 1, title: '霸道总裁的甜蜜契约', author: '月下蝶影', tags: ['甜宠', '恋爱'], heat: '9.8', icon: 'ri-fire-fill', iconColor: 'text-red-500' },
  { rank: 2, title: '校草大人请多指教', author: '星野琉璃', tags: ['校园', '纯爱'], heat: '9.7', icon: 'ri-fire-fill', iconColor: 'text-orange-500' },
  { rank: 3, title: '青梅竹马的恋爱日记', author: '春日暖阳', tags: ['治愈', '甜宠'], heat: '9.6', icon: 'ri-fire-fill', iconColor: 'text-amber-500' },
  { rank: 4, title: '我的恶魔男友', author: '夜樱', tags: ['奇幻', '恋爱'], heat: '9.5', icon: 'ri-fire-line', iconColor: 'text-primary-500' },
  { rank: 5, title: '樱花树下的约定', author: '清风徐来', tags: ['校园', '治愈'], heat: '9.4', icon: 'ri-fire-line', iconColor: 'text-primary-500' },
  { rank: 6, title: '总裁大人有点甜', author: '暮色未央', tags: ['甜宠', '日常'], heat: '9.3', icon: 'ri-fire-line', iconColor: 'text-primary-500' },
  { rank: 7, title: '邻家少女恋爱中', author: '雨落长安', tags: ['少女', '纯爱'], heat: '9.2', icon: 'ri-fire-line', iconColor: 'text-primary-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="section-padding bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            人气榜单
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">全网最热甜宠恋爱漫画排行榜</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {RANKING_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#ranking"
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-10 h-10 rounded-full flex items-center justify-center font-black text-lg shrink-0 ${
                idx < 3 ? 'bg-primary-500 text-white' : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500">{item.author}</span>
                  {item.tags.map((tag) => (
                    <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex items-center gap-1 shrink-0">
                <i className={`${item.icon} ${item.iconColor} text-sm`}></i>
                <span className="text-sm font-bold text-foreground-700">{item.heat}</span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="#ranking" className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer">
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}